import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { distinctUntilChanged, filter, map, Subject, takeUntil } from "rxjs";

import { AuthService } from "~core/services/auth.service";
import { AccountType } from "~modules/auth/types/account.types";

/** Renders its content only for a current user whose account is of the given type. */
@Directive({
	selector: '[appAccountType]',
})
export class AccountTypeDirective implements OnInit, OnDestroy {
	@Input() appAccountType: AccountType;

	private directiveDestroyed$: Subject<boolean> = new Subject();

	constructor(
		private readonly templateRef: TemplateRef<unknown>,
		private readonly viewContainer: ViewContainerRef,
		private readonly authService: AuthService
	) {}

	public ngOnInit(): void {
		this.viewContainer.clear();

		// Follows the user rather than reading it once: switching accounts, or changing the
		// account's type on the account page, changes what should be shown.
		this.authService.currentUser$
			.pipe(
				filter((user) => !!user),
				map((user) => user.account?.accountType === this.appAccountType),
				distinctUntilChanged(),
				takeUntil(this.directiveDestroyed$)
			)
			.subscribe((matches) => {
				this.viewContainer.clear();
				if (matches) {
					this.viewContainer.createEmbeddedView(this.templateRef);
				}
			});
	}

	public ngOnDestroy(): void {
		this.directiveDestroyed$.next(true);
		this.directiveDestroyed$.complete();
	}
}
